import {
    ADDITIONSANDTRAININGS_FETCHING,
    ADDITIONSANDTRAININGS_FAILED,
    ADDITIONSANDTRAININGS_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching:false,
    isError: false
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case ADDITIONSANDTRAININGS_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };
        case ADDITIONSANDTRAININGS_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case ADDITIONSANDTRAININGS_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false };
        default:
            return state;
    }
};
